module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAACTSURBVFjD7dTBDYAgDAXQjucYLuMcjsI4xhMx8eDBWPRgQgxKQYsi/cm/wktaAEQEu1XT4c224Il9HzwE0CEIDoBaW1MRLIDtYCqCDUBFsAIoCHaAD5EEcIVIBjhDkACuxABciOSAI4LrJ1SEai5AUKNHsGeclgIAr4/g0zsQk36YMwPIDsgOZDeC/wHkGQqgGIABAnTozO4lq+oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/text.png
// module id = 1621
// module chunks = 0